export type RouteLoadingSurface =
  'portal' | 'quiz' | 'daily' | 'endless' | 'scheduled' | 'confirmation' | 'default';

const ROUTE_LOADING_SURFACE_RULES: ReadonlyArray<{
  surface: Exclude<RouteLoadingSurface, 'default'>;
  pathPrefixes: readonly string[];
}> = [
  { surface: 'portal', pathPrefixes: [routes.partnerPortal] },
  { surface: 'scheduled', pathPrefixes: ['/scheduled-quiz'] },
  { surface: 'confirmation', pathPrefixes: ['/subscription-confirmation'] },
  { surface: 'daily', pathPrefixes: ['/daily', '/daily-challenge'] },
  { surface: 'endless', pathPrefixes: ['/endless-trivia', '/play'] },
  { surface: 'quiz', pathPrefixes: ['/quiz'] },
];

function pathnameMatchesPrefix(pathname: string, prefix: string): boolean {
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

export function resolveRouteLoadingSurface(pathOrUrl: string): RouteLoadingSurface {
  const pathname = pathOrUrl.split(/[?#]/, 1)[0] || '/';
  return (
    ROUTE_LOADING_SURFACE_RULES.find(({ pathPrefixes }) =>
      pathPrefixes.some((prefix) => pathnameMatchesPrefix(pathname, prefix))
    )?.surface ?? 'default'
  );
}
import { routes } from '@/routes';
